import { StyleSheet, View } from 'react-native';

import { Text, UberEatsLogo } from '@fhs/ui';

import DeliveryAddress from './delivery-address';
import DeliveryEta from './delivery-eta';
import DeliveryForm from './delivery-form';

export function CheckoutDeliveryDetails() {
  return (
    <View>
      <View style={styles.uberBox}>
        <Text.Ui size="sm" style={styles.deliveredByText}>
          Delivered by:
        </Text.Ui>
        <UberEatsLogo
          alt="uber eats"
          contentFit="fill"
          style={{ height: 60, width: 120 }}
          accessibilityLabel="uber eats"
          accessibilityRole="image"
        />
      </View>

      <DeliveryAddress />
      <DeliveryEta />
      <DeliveryForm />
    </View>
  );
}

const styles = StyleSheet.create({
  uberBox: {
    marginBottom: 2,
    flexDirection: 'row',
    marginHorizontal: 16,
  },
  deliveredByText: { paddingVertical: 22, paddingRight: 8 },
});
